// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2TraD","errorLogs":"styles_errorLogs__cNhS8"};